import { BreadCrumbs } from "@stenajs-webui/elements";
import * as React from "react";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { routeFactory } from "../../../../../RouteFactory";
import { Customer, HeadAgreement } from "../../copy/types";

interface Props {
  customer: Customer;
  headAgreement: HeadAgreement;
}

export const ActivateHeadAgreementHeader: React.FC<Props> = ({
  customer,
  headAgreement,
}) => {
  return (
    <PageHeader
      title={"Activate header agreement"}
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={customer?.breadCrumbName ?? ""}
            path={routeFactory.productAndPrice.customer.customer({
              customerId: customer.id,
            })}
          />

          <Crumb
            label={String(headAgreement?.headAgreementNumber ?? "")}
            path={routeFactory.productAndPrice.customer.customerHeadAgreement({
              customerId: customer.id,
              headAgreementId: headAgreement?.id ?? "",
            })}
          />
          <Crumb
            path={routeFactory.productAndPrice.headAgreement.activateHeadAgreement(
              {
                customerId: customer.id,
                headAgreementId: headAgreement.id,
              }
            )}
            label={"activate"}
          />
        </BreadCrumbs>
      }
    />
  );
};
